export default "/images/064522a47e2c2ec200312fac9c021206.avif";